import { OfferStatusEnum } from '../../../../features/offers/models/enums/OfferStatusEnum';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-offer-status',
  standalone: false,
  templateUrl: './offer-status.component.html'
})
export class OfferStatusComponent {
  @Input() status: OfferStatusEnum
  offerStatusEnum = OfferStatusEnum

}
